import { Button, Grid, Link } from '@mui/material';
import * as React from 'react';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DraftsIcon from '@mui/icons-material/Drafts';
import { Box } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


export default function AyudaModal(props) {
  const handleClickModal = () => {
    props.handleClose();
  }

  return (
    <>
      <IconButton
        aria-label="close"
        onClick={handleClickModal}
        sx={{
          position: 'absolute',
          right: 8,
          top: 0,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <span className='modal-titulo'>¿Necesitas ayuda? </span>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box sx={{ mt: 4, width: '75%', ml: 8 }}>
            <span className='modal-text'>¡Te conectaremos con a un asesor en este momento!</span>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box sx={{ mt: 3, width: '75%', ml: 8 }}>
            <span className='modal-text-dos'>A trav&eacute;s del navegador un asesor se
              pondr&aacute; en contacto contigo lo antes
              posible, no cierres la ventana</span>
          </Box>
        </Grid>
        <Box sx={{ mt: 3 }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Button variant="contained">De acuerdo</Button>
          </Grid>
        </Box>
        <Box sx={{ mt: 2 }}>
          <div className='modal-bg'>
            <br />
            <Box sx={{ mt: 2, width: '75%', ml: 8 }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div>
                  <LocalPhoneIcon color='primary' />
                  <span className='modal-tel'>Tambi&eacute;n, nos puedes escribir v&iacute;a Whats App</span>
                </div>
              </Grid>
            </Box>
            <Box sx={{ ml: 16 }}>
              <Link
                href='#'
              >
                <span>55 43 26 90 37</span>
              </Link>
            </Box>
            <Box sx={{ mt: 3, width: '75%', ml: 8 }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div>
                  <DraftsIcon color='primary' />
                  <span className='modal-tel'>O nos puedes escribir a trav&eacute;s de email</span>
                </div>
              </Grid>
            </Box>
            <Box sx={{ ml: 16 }}>
              <Link
                href='#'
              >
                <span>hola@inter.mx</span>
              </Link>
            </Box>
            <br />
          </div>
        </Box>
      </Grid>
    </>
  );

}
